import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[modalWizardStepContent]'
})
export class ModalWizardStepContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
